export default "__VITE_ASSET__C557tsMk__"